import _ from "lodash";

export const INDEX_TOLERANCE = 20;

export const transformConfig = (railImageConfig, railsFlipped) => {
    let config = railImageConfig.inspection_images;

    if (_.findIndex(config, { showInModal: true }) > -1) {
        config = config.filter((imageConfig) => !imageConfig.showInModal);
    }
    if (railsFlipped) {
        config = _.clone(config);
        config.reverse();
    }

    return config;
};
